export default __webpack_public_path__ + "static/media/pg.0b80becd.svg";